export default __webpack_public_path__ + "static/media/icon.ecd3bea1.svg";